export const SHARE_LOGIN_FORM_STRINGS = {
  title: 'Log in',
  passwordLabel: 'Password',
  passwordRequired: 'Password is required',
  loginButton: 'Log in',
  loggingInButton: 'Logging in...',
} as const
